<template>
  <div class="common-aside-card">
    <div class="key-info">
      <div class="key-info-icon-container">
        <slot name="key-info-icon" />
      </div>
      <p class="key-info-value">{{ keyInfo }}</p>
      <p class="key-info-label">{{ keyInfoLabel }}</p>
    </div>
    <div class="tip" :class="{ 'tip-green-background': tipGreenBackground }">
      <p v-if="tipKey != null" class="tip-key">{{ tipKey }}</p>
      <p v-if="tipKeyLabel" class="tip-key-label">{{ tipKeyLabel }}</p>
      <p v-else v-for="tip of tipDescription" class="tip-content">{{ tip }}</p>
      <div v-if="tips" v-for="tip in tips" class="tips">
        <p class="tip-title"> {{ tip.tipKey }}</p>
        <p class="tip-content"> {{ tip.tipKeyLabel }}</p>
      </div>
      <div class="tip-icon-container">
        <slot name="tip-icon" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  keyInfo: string
  keyInfoLabel: string
  tips?: { tipKey: string, tipKeyLabel: string }[]
  tipKey?: string
  tipKeyLabel?: string
  tipDescription?: string[]
  tipGreenBackground?: boolean
}>()
</script>

<style lang="scss" scoped>
.common-aside-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  border-radius: 40px;
  overflow: hidden;
  text-align: center;
  background-color: var(--vc-white);

  .key-info {
    background-color: var(--vc-green);
    color: var(--vc-white);
    justify-content: center;


  }

  .tip {
    background-color: var(--vc-white);
    color: var(--vc-green);
    justify-content: center;

    &-content {
      font-size: 22px;
      margin-bottom: 10px;
      font-size: clamp(14px, min(1.5vw, 2vh), 20px);
    }

    &-title {
      font-weight: 600;

      font-size: clamp(16px, min(2vw, 3vh), 26px);
    }

    &-key-label {
      text-transform: uppercase;
    }

    &-green-background {
      background-color: var(--vc-green-0_2);
    }
  }

  .key-info,
  .tip {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-0_5);
    align-items: center;
    height: 100%;
    padding: var(--spacer);
    min-height: 0;
  }

  .key-info-value,
  .tip-key {
    font-weight: 600;
    line-height: 1;
    font-size: clamp(30px, min(4vw, 5vh), 80px);
  }
}
</style>
